import { render, staticRenderFns } from "./PDFVuer.vue?vue&type=template&id=8bc79924&scoped=true&"
import script from "./PDFVuer.vue?vue&type=script&lang=js&"
export * from "./PDFVuer.vue?vue&type=script&lang=js&"
import style0 from "./PDFVuer.vue?vue&type=style&index=0&id=8bc79924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc79924",
  null
  
)

export default component.exports